import { ExternalAuthPageProps } from '@account/account-portal/external-auth'
import icons from '@adl/asset-icons/dist/sprite.svg?raw'
import { GlApp } from '@adl/component-app'
import { ConfigProvider } from '@crystal/config'
import { Microfrontend, MicrofrontendProps, SvgSprite, getCookies, getQueryParams } from '@crystal/core'
import { FeatureFlagsProvider } from '@crystal/feature-flags'
import { TranslationsProvider } from '@crystal/translator'
import { FC } from 'react'

import styles from './adl-utils.module.scss'
import { ExternalAuthPage as ExternalAuthPageComponent } from './components/ExternalAuthPage'

export const FEATURE_FLAGS_PROJECT_NAME = 'account-acquisition'
export const TRANSLATIONS_PROJECT_NAME = 'account-external-auth'
export const TRANSLATIONS_NAMESPACE_NAME = 'default'

export const ExternalAuthPage: FC<MicrofrontendProps<ExternalAuthPageProps>> = props => {
  const featureFlagContext = {
    ...getQueryParams(),
    ...getCookies(),
    ...props.context,
  }

  return (
    <GlApp className={styles.adlUtils}>
      <Microfrontend {...props}>
        <SvgSprite id="gl-theme-icons" source={icons} />
        <ConfigProvider context={props.context}>
          <TranslationsProvider
            context={props.context}
            project={TRANSLATIONS_PROJECT_NAME}
            namespace={TRANSLATIONS_NAMESPACE_NAME}>
            <FeatureFlagsProvider projectName={FEATURE_FLAGS_PROJECT_NAME} context={featureFlagContext}>
              <ExternalAuthPageComponent {...props} />
            </FeatureFlagsProvider>
          </TranslationsProvider>
        </ConfigProvider>
      </Microfrontend>
    </GlApp>
  )
}
